import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMe } from "./auth";
import { useConsentStatus } from "./consentApi";

// Statuses meaning "questionnaire not yet completed" — athlete must finish
// onboarding before reaching the app.
const ONBOARDING_STATUSES = ["onboarding", "partially_filled"];

export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();
  const { t } = useTranslation("common");
  const skipConsent =
    loc.pathname === "/consent" ||
    loc.pathname.startsWith("/onboarding") ||
    loc.pathname === "/questionnaire";
  const { data: consentData, isLoading: consentLoading } = useConsentStatus();

  if (isLoading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center text-zinc-400"
        role="status"
        aria-live="polite"
      >
        {t("loading")}
      </div>
    );
  }
  if (!me) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search + loc.hash }} />;
  if (ONBOARDING_STATUSES.includes(me.status) && !loc.pathname.startsWith("/onboarding") && loc.pathname !== "/questionnaire") {
    if (!me.has_coach && me.onboarding_intro_seen === false) {
      return <Navigate to="/onboarding/intro" replace />;
    }
    return <Navigate to="/questionnaire" replace />;
  }
  if (!skipConsent && !consentLoading && consentData?.needs_consent) {
    return <Navigate to="/consent" replace state={{ from: loc.pathname }} />;
  }
  return <>{children}</>;
}
